export default __webpack_public_path__ + "static/media/emoji-grec.16b9a826.svg";